import { render, staticRenderFns } from "./csv-output.vue?vue&type=template&id=010053dd&scoped=true&"
import script from "./csv-output.vue?vue&type=script&lang=js&"
export * from "./csv-output.vue?vue&type=script&lang=js&"
import style0 from "./csv-output.vue?vue&type=style&index=0&id=010053dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010053dd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VRow,VSubheader})
